// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3kVp6","topBottomGutter":"Layout_topBottomGutter__9SJq7"};